import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Modal } from 'react-bootstrap';
import { confirmable, createConfirmation } from "react-confirm";
import { compose } from "redux";
import { withTranslation } from "react-i18next";
import Constants from "../../utils/constants";
import SVGraphics from "../../assets/SVGraphics";

const ConfirmComposed = ({
                             proceedLabel,
                             cancelLabel,
                             title,
                             message,
                             extraMessage,
                             extraExtraMessage,
                             show,
                             proceed,
                             warningRed,
                             red,
                             hasSVG,
                             titleColorBlack,
                             svgName,
                             alertSize,
                             enableEscape = true,
                             t
                         }) => {
    useEffect(() => {
        document.getElementById('modal-ok-button').focus();
    }, []);

    const messageMargin= title!==''?'mt-[1.5rem] ':' '
    return (
        <div id="modalError" tabIndex="-1" aria-hidden="true" className="backdrop-blur-sm fixed top-0 left-0 right-0 z-50 w-full h-full p-4 overflow-x-hidden overflow-y-hidden md:inset-0 h-modal md:h-full flex items-center justify-center">
            <div className="w-fit h-fit self-center relative items-center justify-center">
                <Modal id={'Confirm-modal-body'} centered={true}
                       show={show} onHide={() => proceed(false)} keyboard={enableEscape} dialogClassName={'app-modal'}>
                    <Modal.Body className={'p-[68px_38.5px_0px_38.5px] rounded-[32px] flex flex-col justify-self-center items-center self-center justify-start w-password h-password gap-[18px] border-gradient-custom ' + alertSize}>
                        {hasSVG &&
                            <SVGraphics className={'w-[4.2rem] h-[4.2rem] ml-auto mr-auto'} svgname={svgName} fill={"#FEFEFE"}/>}
                        <div className={`mt-[1.5rem]
                        font-bold leading-[1.75rem] text-center leading-trim-both text-[30px] ${titleColorBlack? 'text-[#000] ' :'text-white'} leading-trim-both text-capitalize`}>
                            {title}</div>
                        <div className={messageMargin+' text-lg leading-[1.75rem] text-center leading-trim-both text-capitalize text-black'}>
                            {message}
                        </div>
                        <div className={`${cancelLabel !== 'none'?'py-[1.5rem] pl-[2.5] flex justify-between z-[1000]':'py-[2rem] z-[1000]'}`}>
                            <button id={'modal-ok-button'}
                                    // className="border-solid border-[#52007E] rounded-full bg-[#FEFEFE] flex w-[12rem] h-[3rem] justify-center items-center space-x-3 flex-shrink-0 text-[#52007E] text-bold"
                                    className="rounded-[10px] flex w-[429px] h-[56px] justify-center items-center flex-shrink-0 text-white
                                    font-Poppins text-lg z-index-200 font-[500] cursor-pointer text-[16px] button-glow"
                    
                                    onClick={() => proceed(true)} onKeyPress={event => {
                                if (event.key === 'Enter' && cancelLabel === 'none') {
                                    proceed(true);
                                }
                            }}>
                                {proceedLabel}
                            </button>
                            {(cancelLabel !== 'none') ?
                                <button id={'modal-ok-button'}
                                        className=" rounded-full bg-[#52007E] z-[1000] flex w-[14rem] h-[3rem] justify-center items-center space-x-3 flex-shrink-0 text-white font-bold font-Poppins text-lg"
                                        onClick={() => proceed(false)}>
                                {cancelLabel}
                            </button> : <div />}
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    );
};

const Confirm = compose(
    withTranslation()
)(ConfirmComposed);

Confirm.propTypes = {
    proceedLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
    title: PropTypes.string,
    message: PropTypes.string,
    extraMessage: PropTypes.string,
    extraExtraMessage: PropTypes.string,
    show: PropTypes.bool,
    warningRed: PropTypes.bool,
    red: PropTypes.bool,
    proceed: PropTypes.func,
    enableEscape: PropTypes.bool
};

const AlertConfirm = function AlertConfirm(
    { proceedLabel: proceedLabel = "Yes", cancelLabel: cancelLabel = "No", options: options = {} }, message, title) {
    return createConfirmation(confirmable(Confirm))({
        message,
        proceedLabel,
        cancelLabel,
        title,
        ...options
    });
}

export default AlertConfirm;
